import { MessageCircle } from "lucide-react";
import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const WhatsAppButton = () => {
  const [config, setConfig] = useState({
    number: "18091234567",
    message: "Hola, necesito ayuda con la app E1"
  });

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await axios.get(`${API}/config/whatsapp`);
        setConfig(response.data);
      } catch (error) {
        console.error("Error fetching WhatsApp config:", error);
      }
    };
    fetchConfig();
  }, []);

  const handleClick = () => {
    const encodedMessage = encodeURIComponent(config.message);
    const whatsappUrl = `https://wa.me/${config.number}?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <button
      onClick={handleClick}
      data-testid="whatsapp-button"
      className="fixed bottom-20 right-4 w-14 h-14 rounded-full whatsapp-btn flex items-center justify-center transition-all duration-300 hover:scale-110 z-50"
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle className="w-6 h-6 text-white" />
    </button>
  );
};

export default WhatsAppButton;
